import {
  CANDIDATE_ATTACHMENT_MIME_TYPES_BY_FILE_TYPE,
  type CandidateAttachmentFileType,
} from '../models/CandidateAttachmentRules';

interface FileInfo {
  fileName?: string;
  mimeType?: string;
}

export const getCandidateAttachmentFileType = ({
  fileName,
  mimeType,
}: FileInfo): CandidateAttachmentFileType => {
  if (mimeType) {
    if (CANDIDATE_ATTACHMENT_MIME_TYPES_BY_FILE_TYPE.pdf.includes(mimeType)) {
      return 'pdf';
    }
    if (CANDIDATE_ATTACHMENT_MIME_TYPES_BY_FILE_TYPE.word.includes(mimeType)) {
      return 'word';
    }
    if (CANDIDATE_ATTACHMENT_MIME_TYPES_BY_FILE_TYPE.excel.includes(mimeType)) {
      return 'excel';
    }
  }

  const lowerName = fileName?.toLowerCase() ?? '';
  if (lowerName.endsWith('.pdf')) {
    return 'pdf';
  }
  if (lowerName.endsWith('.docx') || lowerName.endsWith('.doc')) {
    return 'word';
  }
  if (lowerName.endsWith('.xlsx') || lowerName.endsWith('.xls')) {
    return 'excel';
  }

  return 'unknown';
};
